import PlayAuthRedirectRoute from './PlayAuthRedirectRoute';

export default PlayAuthRedirectRoute;
